import React, { useEffect, useState } from 'react'
import { FaEdit } from 'react-icons/fa'
import Empty from '../feedback/Empty'
import Loading from '../feedback/Loading'
import moment from 'moment'
import adminServices from '../../services/AdminServices'
import BookingModal from '../houses/BookingsModal'

function AdminBookings() {
    const [bookings, setBookings] = useState([])
    const [loading, setLoading] = useState(false)
    const [isEditModalOpen, setIsEditModalOpen] = useState(false)
    const [selectedBooking, setSelectedBooking] = useState(null)

    useEffect(() => {
        fetchBookings()
    }, [])

    const fetchBookings = () => {
        setLoading(true)
        adminServices.listBookings()
            .then(res => {
                setBookings(res.data.results || res.data || [])
            })
            .catch(err => console.error('Failed to fetch bookings:', err))
            .finally(() => setLoading(false))
    }

    const handleEdit = (booking) => {
        setSelectedBooking(booking)
        setIsEditModalOpen(true)
    }

    const handleModalClose = () => {
        setIsEditModalOpen(false)
        setSelectedBooking(null)
        fetchBookings()
    }

    return (
        <div className="space-y-5 w-full">
            <div className="flex justify-between items-center">
                <h3 className='text-xl text-primary font-bold'>
                    Guest Bookings{' '}
                    <span className='ml-2 text-on-surface-variant/60 text-base font-normal'>
                        ({bookings.length})
                    </span>
                </h3>
            </div>

            <div className="bg-white rounded-xl border border-outline-variant/15 overflow-hidden">
                <div className='overflow-x-auto'>
                    <table className="table table-zebra w-full">
                        <thead>
                            <tr>
                                <th>Guest</th>
                                <th className='hidden md:table-cell'>Property</th>
                                <th className='hidden md:table-cell'>Check-in → Check-out</th>
                                <th>Nights</th>
                                <th>Total</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {bookings?.length ? (
                                bookings.map(booking => {
                                    const daysBetween = (new Date(booking.check_out) - new Date(booking.check_in)) / (1000 * 60 * 60 * 24)
                                    return (
                                        <tr key={booking.id}>
                                            <td className=" ">
                                                <p className='text-primary font-semibold'>{booking.full_name}</p>
                                                <p className='text-sm'>
                                                    <a
                                                        target='_blank'
                                                        href={`mailto:${booking.user_email}`}
                                                        className="text-on-surface-variant/50 hover:underline truncate block max-w-[150px]" 
                                                        rel="noreferrer">
                                                        {booking.user_email}
                                                    </a>
                                                </p>
                                            </td>
                                            <td className="hidden md:table-cell">{booking.property_title}</td>
                                            <td className="hidden md:table-cell">
                                                <div className="text-sm">
                                                    <div>{moment(booking.check_in).format('MMM D')}</div>
                                                    <div className="text-on-surface-variant/50 text-xs">{moment(booking.check_out).format('MMM D')}</div>
                                                </div>
                                            </td>
                                            <td>
                                                <span className="badge badge-ghost badge-sm">{Math.round(daysBetween)}</span>
                                            </td>
                                            <td className="font-medium">
                                                KES {parseFloat(booking.total_price).toLocaleString()}
                                            </td>
                                            <td>
                                                <div className="flex gap-2">
                                                    <button
                                                        onClick={() => handleEdit(booking)}
                                                        className='btn btn-secondary btn-sm rounded-xl text-white'
                                                        title="Edit Details"
                                                    >
                                                        <FaEdit /> Edit
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            ) : null}
                        </tbody>
                    </table>

                    {loading && <Loading />}
                    {!bookings?.length && !loading && (
                        <div className="p-6">
                            <Empty objectName="bookings yet" />
                        </div>
                    )}
                </div>
            </div>

            <BookingModal
                isOpen={isEditModalOpen}
                onClose={handleModalClose}
                mode="update"
                data={selectedBooking}
            />
        </div>
    )
}

export default AdminBookings